import React from "react";
import { Oval } from "react-loader-spinner";
export default function CustomLoader({width = 150,height = 150}) {
  return (
    <div className="oval-loading">
      <Oval
        height={height}
        width={width}
        color={`${"#333"}`}
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor={`${"#333"}`}
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
}
